import { useSlateStatic } from 'slate-react';
import { useTagSplitContinuation } from 'slate/extensions/tag';
import { useEditorDocument } from 'app/api/documents/useEditorData';

export const TagSplitContinuation = ({ canEditTags }: { canEditTags: boolean | undefined }) => {
  const { data: pDocument } = useEditorDocument();
  useTagSplitContinuation(useSlateStatic(), pDocument?.superId, canEditTags);
  return null;
};
